import React from 'react';
import PropTypes from 'prop-types';
import { Stack, Chip, Typography, Button } from '@mui/material';
import UsbIcon from '@mui/icons-material/Usb';
import UsbOffIcon from '@mui/icons-material/UsbOff';

export default function DeviceHeader({ deviceInfo, onDisconnect }) {
  return (
    <Stack direction="row" alignItems="center" justifyContent="space-between" sx={{ mb: 2 }}>
      <Stack direction="row" alignItems="center" spacing={1.5}>
        <Chip
          icon={<UsbIcon />}
          label="Connected"
          color="success"
          variant="outlined"
          size="small"
        />
        <Typography variant="subtitle1">
          {deviceInfo?.device || 'VPSI Sensor'}
        </Typography>
      </Stack>
      <Stack direction="row" alignItems="center" spacing={1.5}>
        {deviceInfo?.firmware && (
          <Typography variant="body2" color="text.secondary">
            Firmware v{deviceInfo.firmware}
          </Typography>
        )}
        <Button
          variant="outlined"
          color="error"
          size="small"
          startIcon={<UsbOffIcon />}
          onClick={onDisconnect}
        >
          Disconnect
        </Button>
      </Stack>
    </Stack>
  );
}

DeviceHeader.propTypes = {
  deviceInfo: PropTypes.shape({
    firmware: PropTypes.string,
    device: PropTypes.string,
  }),
  onDisconnect: PropTypes.func.isRequired,
};
